import { render } from "./2HeroContent.vue?vue&type=template&id=b805f4a0&scoped=true"
import script from "./2HeroContent.vue?vue&type=script&lang=js"
export * from "./2HeroContent.vue?vue&type=script&lang=js"

import "./2HeroContent.vue?vue&type=style&index=0&id=b805f4a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b805f4a0"]])

export default __exports__